import { HCP_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { TA_FILTER_LIMIT } from '../../filterDefaultLimits';

const TA_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.specialty`],
  limit: TA_FILTER_LIMIT,
});

const therapeuticAreaFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcpPrimarySpecialityLabel',
  sourceCube: HCP_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: TA_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_CUBE_NAME}.specialty`),
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.hcpPrimarySpecialityPlaceholder',
  searchable: true,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${HCP_CUBE_NAME}.specialty`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default therapeuticAreaFilter;
